export default "__VITE_ASSET__$5a8kcVa__"